module.exports = __webpack_public_path__ + "img/dots.8ad5f0a1.svg";